export default {
  skipToContent: {
    id: 'a11y_skip_to_content',
    defaultMessage: 'Skip to content',
  },
}
